import { ThisReceiver } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { LocalStorageService, SessionService } from 'brainloper-ui';

@Component({
  selector: 'app-fixed-notification',
  templateUrl: './fixed-notification.component.html',
  styleUrls: ['./fixed-notification.component.scss']
})
export class FixedNotificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}
